import type { FaireProductEntity } from "../../entity_types/product";

export const p_7pfyxf4v34: FaireProductEntity = {
  token: "p_7pfyxf4v34",
  type: "product",
  name: "Happy Chickens Swedish Dishcloth | Farmhouse kitchen",
  brandToken: "b_146eae49",
  brandName: "Sweetgum Home",
  imageUrl:
    "https://cdn.faire.com/fastly/5e9b96f621d0fcae4c77f3bac3ebac3aa2a5f2cf48cf5941c57dc3a2d5591343.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/35eda95df5f4ba534504c6861bbc1518b008d2e10cbbc2628117fbe106dbc6ae.jpeg",
    "https://cdn.faire.com/fastly/cfba83bf9d3be92c9ef69795a08e21a5b25af9688de7febe6fa4867cec831402.jpeg",
    "https://cdn.faire.com/fastly/19cd9c5db4591f04239e2a6af22bf352dcd02dc6f99a68d9a082285eafef092f.jpeg",
  ],
  priceDollars: 3,
  description:
    'Swedish dishcloths make a great alternate to disposable paper towels and icky smelling plastic sponges... hello happy, healthy home!\n\nThese "gals" will clear every crumb, drip and spill off your kitchen counters, and become your "go to" for all your general household cleaning: cleaning mirrors and windows (streak-free!), wiping down the sink, cabinet fronts, stainless steel appliances, glass stove top, the high chair tray... and the list goes on!\n\nWhat makes our dishcloths special?\n * 100% Natural fibers made from the highest quality wood cellulose sourced from Norway: 70% Cellulose (wood pulp) & 30% Cotton\n * Size: 8" x 6.75" (size of a washcloth) \n * Incredibly absorbent & fast drying \n * Machine washable (up to 50 times) and bleach safe \n * Use in place of paper towels \n * 100% biodegradable: Use for 6-9 months then compost! \n* Designs that add happy to your day :)\n  \nFarmhouse kitchen | Spring cleaning | Modern Farmhouse | Housewarming and hostess gift | eco-friendly gift',
  tags: [],
  msrpDollars: 6.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:36.977Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
